import gql from "graphql-tag";

import {useQuery} from "@repo/data-gql";
import {gqlOp} from "@repo/data-gql-core";

import type {
    userMayInputImages,
    userMayInputImagesVariables,
} from "./__graphql-types__/userMayInputImages.ts";

export const USER_MAY_INPUT_IMAGES_QUERY = gqlOp<
    userMayInputImages,
    userMayInputImagesVariables
>(gql`
    query userMayInputImages {
        user {
            id
            includesDistrictOwnedData
            districtEnableImageInput
        }
    }
`);

export function useUserMayInputImages() {
    const [result] = useQuery(USER_MAY_INPUT_IMAGES_QUERY, {
        variables: {},
        skip: false,
    });

    if (!result || result.status !== "success") {
        return false;
    }

    if (!result.data?.user) {
        return false;
    }

    if (!result.data.user.includesDistrictOwnedData) {
        return true;
    }

    return result.data.user.districtEnableImageInput ?? false;
}
